/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { OverviewViewsEffects } from './overview-views/overview-views.effects';
import { OverviewViewsFeature } from './overview-views/overview-views.reducer';
import { OverviewLocationsEffects } from './overview-locations/locations.effects';
import { OverviewLocationsFeature } from './overview-locations/locations.reducer';

import { OverviewStatisticsFeature } from './overview-statistics/overview-statistics.reducer';
import { OverviewStatisticsEffects } from './overview-statistics/overview-statistics.effects';

import { OverviewAnytimeWitnessFeature } from './overview-anytime-witness/overview-anytime-witness.reducer';
import { OverviewAnytimeWitnessEffects } from './overview-anytime-witness/overview-anytime-witness.effects';
import { LocationsFeature } from './locations/locations.reducer';
import { LocationsEffects } from './locations/locations.effects';

import { OverviewActionsFeature } from './overview-actions/overview-actions.reducer';
import { OverviewActionsEffects } from './overview-actions/overview-actions.effects';
import { OverviewNotificationFeature } from './overview-notifications/overview-notifications.reducer';
import { OverviewNotificationsEffects } from './overview-notifications/overview-notifications.effects';

export function provideMidasAdminDataAccess() {
  return [
    provideState(OverviewViewsFeature),
    provideState(OverviewLocationsFeature),
    provideState(OverviewStatisticsFeature),
    provideState(OverviewAnytimeWitnessFeature),
    provideState(LocationsFeature),
    provideState(OverviewActionsFeature),
    provideState(OverviewNotificationFeature),
    provideEffects([
      OverviewViewsEffects,
      OverviewLocationsEffects,
      OverviewStatisticsEffects,
      OverviewAnytimeWitnessEffects,
      LocationsEffects,
      OverviewActionsEffects,
      OverviewNotificationsEffects
    ]),
  ];
}
